<template>
     <div id="autocomplete" class="d2-search">
            <div class="d2-searchWrap " id="d2-searchWrap">
                 <input class="d2-search__input"
                data-autocomplete
                :placeholder="$t('search')"
                aria-label="Search for Games, Apps, etc..."
                v-model="search_input"
                @keyup="search(search_input)"
            >
                <label id="searchBtn">
                    <span class="icon d2-search__icon" id="sear"></span>
                </label>
            </div>
           
            <div id="auto_result" class="d2-mobiAutocomplete">
              <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-for="(post, index) in result_search" :key="index" v-html="icon_bold[index]" v-on:click="getDetail(post.id)">
                <!-- <router-link class="d2-d2-mobiAutocomplete__resultItem" v-for="(post, index) in result_search" :key="index" v-html="icon_bold[index]"
                    :to="{
                        name: 'DetailPage',
                        params: { id: post.id }
                    }" >{{ index }}</router-link> -->
              </a>
              <p class="autocomplete-result-list" id='searchSuggestion'></p>
            </div>
        </div>
</template>

<script>
import axios from "axios";
import gsap, { TimelineLite } from "gsap";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null
    };
  },
  computed: mapGetters(["lang_gamebox", "host_gamebox"]),
  mounted() {
    //search ani timeline instance
    const navigation = document.getElementsByClassName("d2-navigation")[0];
    const widthToExp = navigation.getBoundingClientRect().width - 180;
    const searchSuggestion = document.getElementById("searchSuggestion");
    const searchWrap = document.getElementById("d2-searchWrap"),
      backdrop = document.getElementById("backdrop");

    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", e => {
      this.search_input = "";
      this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      // this.searchAniTl.reverse();
      // d2 - searchWrap.classList.remove("d2-searchWrap--expand");
    });
  },
  methods: {
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    search(input) {
      const autoComplete = document.getElementById("auto_result");
      const searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        let live = `http://cook.grabmobi.com/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=${input}&domain=${this.host_gamebox}`;
        let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/newcontent_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=${input}&domain=${this.host_gamebox}`;

        axios.get(live).then(res => {
            let search = res.data.data;
            let count = 0;
            let z = [];

            for (let i = 0; i < search.length; i++) {
              if (count <= 15) {
                this.count = count;
                z.push(search[i]);
              }
              count++;
            }
            this.result_search = z;

            let not_match = require(`../../locales/gamebox/${this.lang_gamebox}.json`);

            if (z.length < 1) {
              //if the input not match with the data
              searchSuggestion.style.display = "block";
              searchSuggestion.innerHTML = not_match["not_match"];
            }

            let res_search = [];
            let bold = [];
            let img = "";
            let icon = "";
            for (let i = 0; i < z.length; i++) {
              searchSuggestion.style.display = "none";
              searchSuggestion.innerHTML = "";

              let icon = "";
              //use class icon
              let icon_class = [];
              if (z[i].class_icon != null) {
                icon_class = JSON.parse(z[i].class_icon);
              } else {
                icon_class = null;
              }

              if (icon_class != null) {
                for (let [key, value] of Object.entries(icon_class)) {
                  if (key == this.host_gamebox) {
                    icon = icon_class[key]["class"];
                  } else {
                    icon = icon_class["games4all.vip"]["class"];
                  }
                }
              }

              //to show the bold text
              let rs = z[i].content_name;
              let t_char = rs.search(rgxp) + input.length;
              let re = rs.substring(rs.search(rgxp), t_char);
              let str = rs.replace(rgxp, `<b><i>${re}</i></b>`);
              res_search.push(str);

              //use class icon
              let r = res_search[i].replace(
                res_search[i],
                `<span class='${icon} icon'></span> <p class='d2-h4'> ${res_search[i]}</p> `
              );

              bold.push(r);
              this.icon_bold = bold;
            }
          })
          .catch(err => {
            //console.log(err);
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.d2-search {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-left: 8px;
}
.d2-searchWrap {
  position: relative;
  width: 320px;
  label {
    margin: 0;
    left: 0;
    top: 50%;
    width: 38px;
    transform: translateY(-50%);
    position: absolute;
    cursor: pointer;
  }
  .icon {
    display: inline-block;
    vertical-align: middle;
    &::before {
      color: #fff;
      font-size: 21px;
    }
  }
}
.d2-search__icon {
  &::before,
  &::after {
    content: "";
    margin: auto;
    position: absolute;
    transition: all 0.3s ease-in-out;
  }
  &::before {
    top: 14px;
    right: 0;
    bottom: 0;
    left: 13px;
    width: 10px;
    height: 2px;
    background: #fff;
    transform: rotate(45deg);
  }

  &::after {
    top: -5px;
    right: 0;
    bottom: 0;
    left: -5px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #fff;
  }
}

.d2-searchWrap--expand .d2-search__icon {
  &::before {
    top: 0;
    left: 0;
    width: 25px;
    background: #ccc;
  }
  &::after {
    top: 0;
    left: 0;
    width: 25px;
    height: 2px;
    border: none;
    background: #ccc;
    border-radius: 0%;
    transform: rotate(-45deg);
  }
}
.d2-search__input {
  appearance: none;
  outline: none;
  box-shadow: none;
  border: 0px;
  color: #fff;
  width: 100%;
  height: 38px;
  line-height: 38px;
  padding: 12px 15px 12px 35px;
  font-size: 1.2rem;
  background-color: #00296a;
  cursor: pointer;
  border-radius: 2px;
  &:focus {
    box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  }
}
.d2-search__input::placeholder {
  color: grey;
}
.d2-searchWrap--expand .d2-search__input {
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
}
#auto_result {
  display: none;
}
.d2-mobiAutocomplete {
  position: absolute;
  top: 38px;
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  background: #133692;
  max-height: 480px;
  overflow: auto;
  z-index: 9;
}
.d2-mobiAutocomplete__resultItem {
  display: block;
  color: #000;
  padding: 8px;
  text-decoration: none;
  font-weight: 1rem;
}
/*#autocomplete {
    max-width: 400px;
    margin: 0 auto;
    position: absolute;
    background: white;
    border: 1px solid gainsboro;
    border-radius: 10px;
}

.autocomplete-input{
    max-width: 400px;
    width: 100%;
    border: 0px;
    border-radius: 10px;
    padding: 5px;
}*/

.autocomplete-result-list {
  cursor: pointer;
  display: block;
  color: black;
  text-decoration: none;
  margin: 0px;
  padding: 8px;
  text-transform: uppercase;
}
@media (max-width: 991px) {
  .d2-search {
    display: none;
  }
}

.ar_layout {
  .d2-mobiAutocomplete__resultItem {
    direction: rtl;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/Search.vue